import {Component, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';

import {KeycloakService, UserService} from '@amlCore/services';
import {AlertService} from "@amlCore/components";
import {Utils} from "@amlCore/utils";
import {ProfileService} from "@amlCore/services";
import { animate, style, transition, trigger } from '@angular/animations';
import moment from "moment";
import {map} from "rxjs/operators";

@Component({
  selector: 'app-auth-page',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss'],
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [
        style({opacity:0}),
        animate(1000, style({opacity:1}))
      ])
    ])
  ]
})
export class AuthComponent implements OnInit {
  title = 'Авторизация';
  isSubmitting = false;
  authForm: UntypedFormGroup;
  public userRoleDesc: string;
  activeTab: 'caml' | 'ldap';
  isLDAPEnabled: boolean;

  constructor(private readonly route: ActivatedRoute,
              private readonly router: Router,
              private readonly userService: UserService,
              private readonly fb: UntypedFormBuilder,
              private readonly alertSrv: AlertService,
              private readonly profileService: ProfileService,
              private readonly keycloakService: KeycloakService) {
    /**
     * Форма регистрации
     */
    this.authForm = this.fb.group({
      login: ['', Validators.required],
      password: ['', Validators.required]
    });
  }

  ngOnInit(): void {
    this.userService.checkLDAPEnabled().subscribe(data => (data.enabled === true) ? (this.activeTab = 'ldap', this.isLDAPEnabled = true) : (this.activeTab = 'caml', this.isLDAPEnabled = false));
    if (this.route.snapshot.queryParamMap.has('success')) {
      this.keycloakService.setKeycloakAuth(this.route.snapshot.queryParamMap);
      if (this.keycloakService.isKeycloakSuccess && this.keycloakService.keycloakToken) {
        this.userService.getAuthInfo().pipe(map(data => ({...data, ...this.userService.getUserSession()})))
          .subscribe(authData => {
            this.userService.setAuth(authData);
            this.userService.getProperties().subscribe(properties => {
              this.userService.getAlertProperties(properties);
            })
            this.getUserRoleInfo();
            this.userService.showMenu$.next(true);
            if (this.keycloakService.lastUserLogon) {
              const isoDate = moment(Number(this.keycloakService.lastUserLogon)).utc().format("YYYY-MM-DDTHH:mm:ss.SSSZZ");
              this.alertLastLogon(isoDate);
            }
            this.router.navigateByUrl(this.userService.getStartPageUser(authData));
          });
      } else {
        this.alertSrv.error(this.keycloakService.errorMessage, undefined, undefined, 10 * 1000);
      }
    }
  }

  submitForm(): void {
    this.isSubmitting = true;

    const credentials = this.authForm.value;
    this.userService
      .attemptAuth(credentials, this.activeTab)
      .subscribe(
        (data: any) => {
          const authData = {...data.body, sessionId: data?.headers?.get('Session-Id'), sessionTimeout: data?.headers?.get('Session-Timeout') * 60};
          if (authData.needChangePassword) {
            this.router.navigateByUrl('/changePassword');
            return;
          }
          if (authData.lastSystemLogon) {
            this.alertLastLogon(authData.lastSystemLogon);
          }
          this.getUserRoleInfo();
          this.router.navigateByUrl(this.userService.getStartPageUser(authData));
        },
        err => {
          this.isSubmitting = false;
        }
      );
  }
  getUserRoleInfo() {
    this.profileService.getUserInfo().subscribe((data) => {
      this.profileService.userRoleDesc$.emit(data.userRole.name);
      sessionStorage.setItem('userRole', data.userRole.name);
    });
  }

  getCustomPatterns(): object {
    return Utils.customPatterns;
  }

  changeTab(type: 'caml' | 'ldap'): void {
    this.activeTab = type;
    this.authForm.reset();
  }

  alertLastLogon(lastLogon: string) {
    this.alertSrv.primary(`Последний вход был в ${moment(lastLogon)
      .format('HH:mm:ss, DD-MM-YYYY')}`, undefined, undefined, 60000, true);
  }
}
